export default (str) => {
  /*
   * 1000 to 6999 range national flights numbers
   * 7000 to 8999 range international
   * come with or whitout iata_code
   */
  return str.split('').reverse().join('').substring(0, 4).split('').reverse().join('')
}
